import styled from 'styled-components'

export const Container = styled.div`
    margin: 2rem auto;
    max-width: 400px;
    padding: 2rem;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`

export const Title = styled.h2`
    margin-bottom: 1rem;
    font-size: 1.5rem;
    color: #333;
`

export const Form = styled.form`
    display: flex;
    flex-direction: column;
`

export const Input = styled.input`
    padding: 0.75rem;
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
    width: 100%;
    box-sizing: border-box;
    &:focus {
        border-color: #007bff;
        outline: none;
    }
`

export const ErrorMessage = styled.span`
    color: red;
    margin-bottom: 2rem;
    margin-top: 1rem;
`

export const SubmitButton = styled.button`
    padding: 0.75rem;
    border: none;
    border-radius: 4px;
    background-color: #ba9d31;
    color: white;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
    &:hover {
        background-color: #8b761b;
    }
`
